import { MessageBox } from 'element-ui';
import router, { asyncRoutes } from "@/router";
import { removeToken } from "@/utils/auth";
import createRoutes from "@/utils/createRoutes";

export default {
    namespaced: true,
    state: {
        init: false,
        userInfo: {},
        userInfoDetail: {},
        routes: [],
        btnPermissions: [],
        adminRoute: "",
        downListShow: false,
        downListVisible: false,
        hisVisible: 0,
        asyncTaskShow: false,
        asyncTaskVisible: false,
        signCount: 0,
        warnCount: 0
    },
    mutations: {
        SET_INFO(state, data) {
            state.userInfo = data;
        },
        ADD_ROUTES(state, data) {
            state.routes = data;
            state.init = true;
        },
        SET_USERINFO(state, data) {
            state.userInfoDetail = data;
        },
        SET_ADMIN_ROUTE(state, data) {
            state.adminRoute = data;
        },
        SET_BTN_PERMISSIONS: (state, data) => {
            state.btnPermissions = data
        },
        SET_DOWN_LIST_VISIBLE: (state, data) => {
            state.downListVisible = data
        },
        SET_DOWN_LIST_SHOW: (state, data) => {
            state.downListShow = data
        },
        SET_HIS_VISIBLE: (state, data) => {
            state.hisVisible = data
        },
        SET_ASYNC_TASK_SHOW: (state, data) => {
            state.asyncTaskShow = data
        },
        SET_ASYNC_TASK_VISIBLE: (state, data) => {
            state.asyncTaskVisible = data
        },
        SET_SIGN_COUNT(state, data){
            state.signCount = data
        },
        SET_WARN_COUNT(state, data){
            state.warnCount = data
        }
    },
    actions: {
        getInfo({ commit }, data) {
            return new Promise((resolve, reject) => {
                api
                    .login({
                        token: data
                    })
                    .then(res => {
                        commit("SET_INFO", res);
                        resolve(res);
                    })
                    .catch(err => {
                        removeToken();
                        router.go(0);
                    });
            });
        },
        getUserInfo({ commit }, data) {
            return new Promise((resolve, reject) => {
                api.getUserInfo().then(
                    res => {
                        if (res.status == 200) {
                            if (res.data.me == null) {
                                removeToken();
                                router.go(0);
                                return;
                            }
                            global.anchor_id = res.data.me.id;
                            // global.anchor_id = 1892
                            commit("SET_USERINFO", res.data.me);
                            commit("SET_ADMIN_ROUTE", res.data.admin_route);
                            commit("SET_DOWN_LIST_SHOW", res.data.have_download_list == 1);
                            commit("SET_SIGN_COUNT", res.data.append_time_check_count)
                            commit("SET_WARN_COUNT", res.data.promotion_warning_count)
                            commit("SET_ASYNC_TASK_SHOW", res.data.have_async_list == 1);
                            resolve(res.data);
                        }
                    },
                    err => {
                        removeToken();
                        router.go(0);
                    }
                );
            });
        },
        generateRoutes({ commit }, data) {
            return new Promise((resolve, reject) => {
                api.getWebPermissions().then(res => {
                    if(res.status == 200){
                        let filterRoutes = createRoutes(asyncRoutes, res.data.permission_list);
                        commit("ADD_ROUTES", filterRoutes.slice(0));
                        if(filterRoutes.length == 0){
                            return MessageBox.alert('该账号没有权限！', '', {
                                customClass: 'el-message-box_alert',
                                confirmButtonText: '我已知晓',
                                showConfirmButton: true,
                                center: true,
                                callback: action => {
                                    removeToken();
                                    router.go(0);
                                }
                            })
                        }
                        filterRoutes.unshift({
                            path: "/",
                            redirect: filterRoutes[0].redirectPath
                        });
                        filterRoutes.push({
                            path: "*",
                            redirect: '/nopermission/index'
                        });
                        resolve(filterRoutes);
                    }
                })
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js